var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 19,
  fill: "none",
  viewBox: "0 0 27 19",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#clip0_14716_15742)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.27 2.69H18.8L17.26.38C17.11.15 16.69 0 16.21 0h-5.57c-.47 0-.9.15-1.05.38L8.05 2.69H2.59A2.59 2.59 0 0 0 0 5.28v10.94a2.59 2.59 0 0 0 2.59 2.59h21.68a2.59 2.59 0 0 0 2.59-2.59V5.28a2.59 2.59 0 0 0-2.59-2.59M13.43 16.73c-3.71 0-6.72-3.01-6.72-6.72s3.01-6.72 6.72-6.72 6.72 3.01 6.72 6.72-3.01 6.72-6.72 6.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.43 15.11a5.1 5.1 0 1 0 0-10.2 5.1 5.1 0 0 0 0 10.2"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.f507de16ab40981f9cfa485874cd17f4.svg";